import { KitText } from '@omni/kit/components';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import * as React from 'react';
import { ReactElement } from 'react';
import { StyleSheet, View } from 'react-native';

export default function ReplySeparator({
  replyCount,
}: {
  replyCount: number;
}): ReactElement {
  return (
    <View style={styles.container}>
      <KitText fontSize={12} gray semiBold>
        {replyCount === 1 ? `${replyCount} reply` : `${replyCount} replies`}
      </KitText>
      <View style={styles.line} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    marginLeft: Spacing.m,
    marginTop: Spacing.m,
  },
  line: {
    backgroundColor: Colors.N100,
    flex: 1,
    height: 1,
    marginHorizontal: Spacing.m,
  },
});
